import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaApoyos from './TablaApoyos';

const Apoyos: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaApoyos />
    </Box>
  );
};

export default Apoyos;
